<template>
  <div class="area-spline-skeleton">
    <SkeletonHeader />
    <div class="area-spline-skeleton__body">
      <div class="area-spline-skeleton__chart">
        <v-skeleton-loader
          type="text"
          class="area-spline-skeleton__wave"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { SkeletonHeader } from '@/components/base';

export default {
  name: 'AreaSplineSkeleton',
  components: {
    SkeletonHeader,
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .area-spline-skeleton {
    &__body {
      width: 100%;
    }

    &__chart {
      background:
        repeating-linear-gradient(
          to bottom,
          var(--ds-color-silver) 0,
          var(--ds-color-silver) 1px,
          var(--ds-color-neutral) 1px,
          var(--ds-color-neutral) 60px
        );

      .v-skeleton-loader.v-skeleton-loader--is-loading .v-skeleton-loader__text {
        border-radius: 20px;
        height: 240px;
      }
    }

    &__wave {
      --mask:
        radial-gradient(
          121.74px at 50% calc(100% + 80.1px),
          #0000 calc(99% - 4px),
          #000 calc(101% - 4px) 99%,
          #0000 101%
        )
        calc(50% - 178px) calc(50% - 46.5px + 0.5px)/356px 93px repeat-x,
        radial-gradient(
          121.74px at 50% -80.1px,
          #0000 calc(99% - 4px),
          #000 calc(101% - 4px) 99%,
          #0000 101%
        )
        50% calc(50% + 46.5px)/356px 93px repeat-x;

      -webkit-mask: var(--mask);
      mask: var(--mask);
      background: linear-gradient(90deg, rgba(245, 245, 245, 1) 0%, rgba(210, 210, 212, 1) 80%);
      height: 100%;
    }
  }
}
</style>
